module.exports = __webpack_public_path__ + "static/img/M-600-VANILLA-STIX.36e7610.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-600-VANILLA-STIX.png
// module id = kyoD
// module chunks = 0